
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from "react";
import Zergling from '../../../../dev/helpers/zergling';

class FreeBetBonus extends Component {
    constructor (props) {
        super(props);
        this.state = {
            data: null,
            loading: true
        };
    }
    componentDidMount () {
        Zergling.get({ "free_bonuses": true }, "get_bonus_details")
            .then((response) => {
                this.setState({ data: response, loading: false });
            })
            .catch(() => {
                this.setState({loading: false});
            });
    }
    render () {
        // eslint-disable-next-line no-undef
        return Template.default.apply(this);
    }
}
export default FreeBetBonus;